// eslint-disable-next-line max-classes-per-file
import { deserialize } from 'cerialize'

export class DadataSuggestByIdPartyModel {
	@deserialize public id: number
	@deserialize public inn: string
	@deserialize public code: number
	@deserialize public body: string
}
